var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42 21c0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0s21 9.402 21 21z",
    fill: props.fill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.594 16.281c0 1.812-1.029 3.282-2.297 3.282-1.269 0-2.297-1.47-2.297-3.282S14.028 13 15.297 13c1.268 0 2.297 1.47 2.297 3.281zM29.406 16.281c0 1.812-1.028 3.282-2.297 3.282-1.268 0-2.297-1.47-2.297-3.282S25.841 13 27.11 13c1.269 0 2.297 1.47 2.297 3.281z",
    fill: "#111827"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 27,
    width: 17,
    height: 4,
    rx: 2,
    fill: "#111827"
  })));
}
export default SvgRate3;